/**
 * CUSTOMER CARE INFO telephone
 *
 *
 * used in cart and account
 *
 *
 */

import * as React from "react";
import { LabelContext } from "../../core/label.context";
import styled from "styled-components";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const CustomercareInfoTelephone = () => {
	const { t } = React.useContext(LabelContext);

	let ecommerce_customerCare_info_telephone = t(
		"ecommerce.customerCare.info.telephone"
	);

	if (!ecommerce_customerCare_info_telephone) return null;
	else {
		return (
			<>
				<TelBox className="customerCareInfo-box-tel align-items-center">
					<div
						className="testo"
						dangerouslySetInnerHTML={{
						__html: ecommerce_customerCare_info_telephone,
						}}
					/>
					<div className="d-flex pl-3 pt-2">
						<span>{t("ecommerce.customerCare.info.times")}</span>
						<OverlayTrigger
							placement="auto"
							overlay={<Tooltip>{t("ecommerce.customerCare.info.times.tooltip")}</Tooltip>}>
							<button className="ec_btn ec_btn-moreInfo">
								<span className="icon"/>
								<span className="testo">{t("ecommerce.checkout.moreInfo")}</span>
							</button>	
						</OverlayTrigger>
					</div>

				</TelBox>
			</>
		);
	}
};

export const TelBox = styled.div`
	@media (max-width: 991.9px) {
		position: fixed;
		top: var(--page-margin);
		left: 0;
		z-index: 1;
		background: #020202;
		opacity: 86%;
		color: white;
		width: 100%;
		padding: 0 15px;
	}
	.testo {
		a {
			text-decoration: underline;
		}
	}
	.ec_btn-moreInfo {
		font-size: inherit;
		color: #020202;
		width: 20px;
		.icon {
			background-image: url('../webfiles/latest/images/icons/ecommerce/icon-info.svg');
			background-repeat: no-repeat;
			width: 20px;
			height: 20px;
			padding: 1px;
			@media (max-width: 991.9px) {
				filter: invert(1);
			}
			&:before {
				content:'';
			}
		}
	}
`;
